export const REASON_FIELD_NAME: string = 'reason'
export const EMAIL_FIELD_NAME: string = 'email'
export const RECAPTCHA_FIELD_NAME: string = 'recaptcha'
